import styled from 'styled-components';

const NoDataCardWrapper = styled.div`
  height: calc(100% - 40px);
`;

export { NoDataCardWrapper };
